import React, { Component } from 'react';
import PoolsChart from 'shared/components/poolsChart';
import PoolRow from 'shared/components/poolRow';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

class LitecoinZ extends Component {
    componentDidMount() {}

    shouldComponentUpdate(nextProps, nextState) {
        return false;
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>{'LitecoinZ mining pools - ltz'}</title>
                    <meta
                        name="description"
                        content="LitecoinZ mining pools stats, mining pools litecoinz list online and chart"
                    />
                    <meta name="keywords" content="LitecoinZ,mining pools,ltz,equihash" />
                </Helmet>
                <div className="my-3 p-3 bg-white rounded box-shadow">
                    {/*<h6 class="border-bottom border-gray pb-2 mb-0">Votecoin pools stats</h6>*/}
                    <div className="table-responsive-md">
                        <table className="table">
                            <thead className="">
                                <tr>
                                    <th className="border-top-0" scope="col">
                                        Pool
                                    </th>
                                    <th className="border-top-0" scope="col">
                                        Hashrate
                                    </th>
                                    <th className="border-top-0" scope="col">
                                        Workers
                                    </th>
                                    <th className="border-top-0" scope="col">
                                        Fee
                                    </th>
                                    <th className="border-top-0" scope="col">
                                        Updated
                                    </th>
                                    <th className="border-top-0" scope="col">
                                        Visit
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <PoolRow
                                    option={{
                                        url: 'https://equipool.1ds.us/api/stats',
                                        link: 'https://equipool.1ds.us',
                                        algo: 'equihash',
                                        coin: 'litecoinz',
                                        pool: '1dsequipool',
                                        poolName: '1ds Equipool',
                                        fee: '0.2',
                                    }}
                                />
                                <PoolRow
                                    option={{
                                        url: 'http://ltz.pcmining.xyz:8080/api/stats',
                                        link: 'http://ltz.pcmining.xyz',
                                        algo: 'equihash',
                                        coin: 'litecoinz',
                                        pool: 'pcminingxyz',
                                        poolName: 'PCMiNing',
                                        fee: '1',
                                    }}
                                />
                                {/*                                <PoolRow
                                    option={{
                                        url: 'https://litecoinz.miningspeed.com/api/stats',
                                        link: 'https://litecoinz.miningspeed.com',
                                        algo: 'equihash',
                                        coin: 'litecoinz',
                                        pool: 'miningspeed',
                                        poolName: 'Miningspeed',
                                        fee: '0.4',
                                    }}
                                />*/}
                                {/*              <PoolRow option={{
                  url: 'http://23.121.186.230:9096/api/stats',
                  link: 'http://ltz.blocksmasher.org',
                  algo: 'equihash',
                  coin: 'litecoinz',
                  pool: 'blocksmasher',
                  poolName: 'BlocksMasher',
                  fee: '1'
                }}
                />*/}
                                {/*                                <PoolRow
                                    option={{
                                        url: 'https://ltz.magnificentpool.com/api/stats',
                                        link: 'https://ltz.magnificentpool.com',
                                        algo: 'equihash',
                                        coin: 'litecoinz',
                                        pool: 'magnificentpool',
                                        poolName: 'MagnificentPool',
                                        fee: '0.5',
                                    }}
                                />*/}
                                {/*                                <PoolRow
                                    option={{
                                        url: 'https://fastblocks.net/api/stats',
                                        link: 'https://fastblocks.net',
                                        algo: 'equihash',
                                        coin: 'litecoinz',
                                        pool: 'fastblocks',
                                        poolName: 'FastBlocks',
                                        fee: '1',
                                    }}
                                />*/}
                                {/*                                <PoolRow
                                    option={{
                                        url: 'https://litecoinz.axepool.com/api/stats',
                                        link: 'https://litecoinz.axepool.com',
                                        algo: 'equihash',
                                        coin: 'litecoinz',
                                        pool: 'axepool',
                                        poolName: 'AxePool',
                                        fee: '1',
                                    }}
                                />*/}
                                {/*                                <PoolRow
                                    option={{
                                        url: 'https://lambomoon.club/api/stats',
                                        link: 'https://lambomoon.club',
                                        algo: 'equihash',
                                        coin: 'litecoinz',
                                        pool: 'lambomoonclub',
                                        poolName: 'LamboMoon',
                                        fee: '5',
                                    }}
                                />*/}
                                {/*                                <PoolRow
                                    option={{
                                        url: 'http://www.abakus.gemini.net.pl/api/stats',
                                        link: 'http://www.abakus.gemini.net.pl',
                                        algo: 'equihash',
                                        coin: 'litecoinz',
                                        pool: 'abakusgemininetpl',
                                        poolName: 'Abakus Mine',
                                        fee: '0',
                                    }}
                                />*/}
                                {/*                                <PoolRow
                                    option={{
                                        url: 'https://coorp.io/public_api/stats',
                                        link: 'https://coorp.io/pool/ltz',
                                        algo: 'equihash',
                                        coin: 'litecoinz',
                                        pool: 'coorpio',
                                        poolName: 'Coorp',
                                        fee: '0.2',
                                    }}
                                />*/}
                                {/*                <PoolRow option={{
                  url: 'https://zpool.wfmpools.com/api/stats',
                  link: 'https://zpool.wfmpools.com',
                  algo: 'equihash',
                  coin: 'litecoinz',
                  pool: 'windfall',
                  poolName: 'Windfall',
                  fee: '1'
                }}
                />*/}
                                {/*                                <PoolRow
                                    option={{
                                        url: 'https://equigems.online/api/stats',
                                        link: 'https://equigems.online',
                                        algo: 'equihash',
                                        coin: 'litecoinz',
                                        pool: 'equigems',
                                        poolName: 'EquiGems',
                                        fee: '0.9',
                                    }}
                                />*/}
                            </tbody>
                        </table>
                    </div>
                    <small className="d-block text-right mt-3">
                        <Link to="/addminingpool" title="Add mining pool">
                            Add mining pool
                        </Link>
                    </small>
                </div>
                <PoolsChart
                    option={{
                        algo: 'equihash',
                        coin: 'litecoinz',
                        title: 'LitecoinZ pools chart',
                    }}
                />
            </div>
        );
    }
}

export default LitecoinZ;
